/** Max number of incomplete-event-FAQ spaces rendered inside the group. */
export const EVENT_FAQ_GROUP_MAX_SPACES = 3;

/** Square thumbnail size (px) used for the space image on each event-FAQ row. */
export const EVENT_FAQ_THUMBNAIL_PX = 120;
